var image_viewer_rtlignore_default = {
  "fontElementMap": "qn--w",
  "imageContainer": "IySXE",
  "expandButton": "Auo0a",
  "expandIcon": "_8kM3N",
  "pointer": "_-2uSA",
  "imageWrapper": "ZYT8Y",
  "imageRatio": "ckerf",
  "image": "_0Q0jB",
  "imageOverlay": "G6Qfa",
  "imagePreload": "w4y0Z",
  "imageHighres": "_2mUc9",
  "onlyHighRes": "e1uIP",
  "image_loading": "APw9L"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
